import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createDraft } from "@services/subscriberSyncUpload";

export function useCreateSubscriberSyncDraft(options: any = {}) {
  const queryClient = useQueryClient();

  return useMutation(createDraft, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["subscriberSyncUploads"] });
    },
    ...options,
  });
}
